import React, { FC, useCallback, useEffect, useState } from 'react';
import { BlockStack, Box } from '@shopify/polaris';
import { EVENTS } from '@/constants/tracking';
import { track } from '@/utils/tracker';
import TermsAndConditions from './TermsAndConditions';
import { ICardMediaAsset } from '@/types/media';
import { getDownloadUrl } from '@/api/download';
import { Modal, TitleBar } from '@shopify/app-bridge-react';

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  media: ICardMediaAsset;
}

export const DownloadMediaModal: FC<Props> = ({ media, isOpen, setIsOpen }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const handleClose = useCallback(() => {
    setIsOpen(false);
    track(EVENTS.DOWNLOAD_MODAL_CLOSED, { id: media.id });
  }, []);

  const handleDownload = useCallback(async () => {
    if (media) {
      setIsDownloading(true);
      const { signedUrl } = await getDownloadUrl({
        s3Key: media.result!,
        filename: media.name!,
      });
      window.open(signedUrl, '_blank');
      setIsDownloading(false);
      setIsOpen(false);
      track(EVENTS.PUBLISH_DOWLOAD, { id: media.id });
    }
  }, [media]);

  useEffect(() => {
    if (isOpen) {
      track(EVENTS.DOWNLOAD_MODAL_OPENED, { id: media.id });
    }
  }, [isOpen]);

  return (
    <Modal open={isOpen} onHide={handleClose}>
      <TitleBar title="Download Media">
        <button onClick={handleClose}>Cancel</button>
        <button variant="primary" loading={isDownloading ? 'true' : undefined} onClick={handleDownload}>
          Download
        </button>
      </TitleBar>
      <Box paddingBlock="200" paddingInline="400">
        <BlockStack gap="400">
          <TermsAndConditions />
        </BlockStack>
      </Box>
    </Modal>
  );
};
